import { useEffect, useState } from 'react';

export const TABLET_BREAKPOINT = 1024;

const matches = (breakpoint: number) =>
    typeof window !== 'undefined' && window.innerWidth <= breakpoint;

/**
 * Suit la largeur du viewport au lieu de la lire une seule fois au montage.
 * Sans ce suivi, la mise en page (sidebar, navbar, workspace Blockly) reste
 * figee sur la taille d'ecran presente au premier rendu : redimensionner la
 * fenetre ou tourner la tablette laissait le layout dans le mauvais mode.
 */
export const useIsTablet = (breakpoint: number = TABLET_BREAKPOINT): boolean => {
    const [isTablet, setIsTablet] = useState<boolean>(() => matches(breakpoint));

    useEffect(() => {
        const onResize = () => setIsTablet(matches(breakpoint));
        onResize();
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [breakpoint]);

    return isTablet;
};

export default useIsTablet;
